var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuTasksSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "#FC959A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 3,
    width: 10,
    height: 25.9999,
    rx: 2,
    transform: "rotate(90 29 3)",
    fill: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 23,
    width: 6,
    height: 25.9999,
    rx: 2,
    transform: "rotate(90 29 23)",
    fill: "#FCFCFC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 15,
    width: 6,
    height: 25.9999,
    rx: 2,
    transform: "rotate(90 29 15)",
    fill: "#FCFCFC"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#FC959A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTasksSelected);
export default __webpack_public_path__ + "static/media/menu-tasks-selected.4aac0e4248ab2e1c3a0c2033ce392f40.svg";
export { ForwardRef as ReactComponent };